"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apiVersionField = void 0;
var apiVersionField = exports.apiVersionField = function apiVersionField(latestVersion) {
  return {
    name: 'apiVersion',
    inputType: 'text',
    required: true,
    label: 'API version',
    isAdvancedField: true,
    defaultValue: (latestVersion === null || latestVersion === void 0 ? void 0 : latestVersion.versionGroup) || 'v1',
    placeholder: 'v1'
  };
};
//# sourceMappingURL=publication.js.map